import React from 'react';

import { CompetitorData } from '../types';

interface CompetitorCardProps {
  competitor: CompetitorData;
  analyzed: boolean;
  isBeaming?: boolean;
  isExpanded?: boolean;
  isCollapsed?: boolean;
  isMini?: boolean;
  style?: React.CSSProperties;
}

export const CompetitorCard: React.FC<CompetitorCardProps> = ({ competitor, analyzed, isBeaming, isExpanded, isCollapsed, isMini, style }) => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
    }, 50); // slight delay to ensure the browser paints the initial "grey bubble" state
    return () => clearTimeout(timer);
  }, []);

  const effectivelyExpanded = mounted && isExpanded;

  return (
    <div
      className={`ms-competitor-card${analyzed ? ' analyzed' : ''}${effectivelyExpanded ? ' expanded' : ''}${isCollapsed ? ' collapsed' : ''}${isBeaming ? ' beaming' : ''}`}
      style={style}
    >
      <div className="ms-pill-skeleton-layer" />
      <div className="ms-pill-border-beam" />
      
      <div className="ms-pill-content">
        <div className="ms-competitor-logo">
          {competitor.logoUrl ? (
            <img src={competitor.logoUrl} alt={competitor.name} />
          ) : (
            <span style={{ fontSize: 12, color: '#8e8e93' }}>
              {competitor.name.charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <span className="ms-competitor-name">{competitor.name}</span>
        <div className={`ms-competitor-check${analyzed ? ' visible' : ''}${isMini ? ' static' : ''}`}>
          {isBeaming ? (
            <svg className="ms-spinner" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          ) : (
            <svg className="ms-check-icon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="#17C964" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
};
